export function captureComponentSnapshot(container) {
  if (!container || !container.firstChild) return null;
  try {
    const styles = Array.from(document.querySelectorAll('style'))
      .map(s => s.textContent)
      .join('\n');
    return `<!DOCTYPE html><html><head><meta charset="utf-8"><style>*,*::before,*::after{box-sizing:border-box}body{margin:0;padding:12px;background:#fff;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;font-size:13px}${styles}</style></head><body>${container.innerHTML}</body></html>`;
  } catch {
    return null;
  }
}

export function createLogCapture() {
  const logs = [];
  const origError = console.error;
  const origWarn = console.warn;

  const capture = (level, orig) => (...args) => {
    const msg = args
      .map(a => (typeof a === 'string' ? a : (() => { try { return JSON.stringify(a); } catch { return String(a); } })()))
      .join(' ')
      .split('\n')[0]
      .slice(0, 300);
    logs.push({ level, msg });
    orig(...args);
  };

  console.error = capture('error', origError);
  console.warn = capture('warn', origWarn);

  return {
    getLogs: () => [...logs],
    restore: () => {
      console.error = origError;
      console.warn = origWarn;
    },
  };
}
